import { Moon, Sun } from 'lucide-react';
import { useDarkMode } from '../../context/DarkModeContext';

export function DarkModeToggle() {
  const { isDark, toggle } = useDarkMode();

  return (
    <button
      onClick={toggle}
      className="p-2 rounded-lg border border-gray-300 bg-white hover:bg-gray-100 dark:border-gray-600 dark:bg-dark-800 dark:hover:bg-gray-700 transition"
      title={isDark ? 'Modo claro' : 'Modo escuro'}
      aria-label={isDark ? 'Ativar modo claro' : 'Ativar modo escuro'}
    >
      {isDark ? (
        <Sun size={20} className="text-yellow-500" />
      ) : (
        <Moon size={20} className="text-gray-600" />
      )}
    </button>
  );
}